<script lang="ts">
	import LoginScreenBox from '../../components/Users/LoginScreenBox.svelte';
	import GraphQLQuery from '../../components/GraphQL/GraphQLQuery.svelte';
	import Button from '../../components/Button.svelte';
	import { GET_URLS_QUERY } from '../../graphql/queries/users';
</script>

<LoginScreenBox>
	<GraphQLQuery query={GET_URLS_QUERY} let:response>
		<a href={response.data.authUrls.azureCode}>
			<Button fullWidth margin variant="raised">
				<img src="/assets/images/azure-1.svg" alt="Azure" />
				Azure Login
			</Button>
		</a>
		<hr />
		<a class="google" href={response.data.authUrls.googleCode}>
			<Button fullWidth margin variant="raised">
				<img src="/assets/images/google-g.svg" alt="Google" />
				Google Login
			</Button>
		</a>
		<div slot="loading">Loading ...</div>
	</GraphQLQuery>
</LoginScreenBox>

<style>
	a {
		min-width: 100%;
	}
	a :global(.mdc-button) {
		height: auto;
		padding: 10px 24px;
	}
	a :global(svg) {
		--size: 24px;
		width: var(--size);
		height: var(--size);
		margin-right: 12px;
	}
	a :global(svg path) {
		fill: var(--mdc-theme-on-primary, #fff);
	}
	a.google :global(svg) {
		width: calc(var(--size) - 2px);
	}
	img {
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}
</style>
